import React from 'react';
import Button from '../../ui/Button';

const PlanCard = ({ plan, index, activeIndex, cardsToShow }) => {
  const isActive = index === activeIndex;
  
  const getCardClass = () => {
    if (isActive) return 'plan-card active';
    return 'plan-card';
  };

  return (
    <div className={getCardClass()}>
      <div className="plan-glow"></div>
      <div className="plan-header">
        <h3>{plan.name}</h3>
        <div className="plan-price">
          <span className="price-amount">{plan.price}</span>
          <span className="price-currency">RSD</span>
          <span className="price-period">/mesečno</span>
        </div>
      </div>
      
      <div className="plan-features">
        <PlanFeature 
          icon="🚿"
          number={plan.number_of_washes}
          text="žetona za paket" 
        />
        <PlanFeature 
          icon="🪙"
          number={plan.number_of_tokens_per_wash}
          text="žetona po svakom pranju" 
        />
      </div>
    </div>
  );
};

const PlanFeature = ({ icon, number, text }) => {
  return (
    <div className="feature">
      <div className="feature-icon-bg">
        <span className="feature-icon">{icon}</span>
      </div>
      <div className="feature-content">
        {number && <span className="feature-number">{number}</span>}
        <span className="feature-text">{text}</span>
      </div>
    </div>
  );
};

export default PlanCard;